import { Component, Input, OnInit } from '@angular/core';
import { AlertMessage } from 'src/app/template/models/alert-message.model';
import { ExtraInfo } from '../../models/extra-info.model';
import { Gender } from '../../../genders/models/gender.model';
import { Student } from '../../models/student.model';
import { StudentService } from '../../services/student.service';

@Component({
    selector: 'app-student-edit',
    templateUrl: './student-edit.component.html',
    styleUrls: ['./student-edit.component.scss']
})
export class StudentEditComponent implements OnInit {

    @Input() student?  : Student;
    @Input() genders   : Gender[];
    @Input() extraInfos: ExtraInfo[];

    public isEdition: boolean = false;

    public isStudentGeneralDataValid   : boolean = false;
    public isStudentSchoolDataValid    : boolean = false;
    public isStudentExtraInforDataValid: boolean = false;

    public isProcessing     : boolean = false;
    public processingMessage: AlertMessage = new AlertMessage();

    constructor(private readonly studentService: StudentService) {}

    ngOnInit (): void {

        this.isEdition = this.student !== null && this.student !== undefined;
        this.student = { ...this.student } ?? new Student();

    }

    public isStudentGeneralDataValidEvent(valid: boolean) {

        this.isStudentGeneralDataValid = valid;
        this.processingMessage.reset();

    }

    public isStudentSchoolDataValidEvent(valid: boolean) {

        this.isStudentSchoolDataValid = valid;
        this.processingMessage.reset();

    }

    public isStudentExtraInforDataValidEvent(valid: boolean) {

        this.isStudentExtraInforDataValid = valid;
        this.processingMessage.reset();

    }

    public isFormValid() {

        return this.isStudentGeneralDataValid && this.isStudentSchoolDataValid && this.isStudentExtraInforDataValid;

    }

    public createOrUpdateEntity() {

        this.isEdition ?
            this.updateEntity() :
            this.createEntity();

    }

    public updateEntity() {

        this.isProcessing = true;
        this.studentService.put(this.student).subscribe({

            next: () => {
                let successMessage = 'Los datos del participante se han actualizado correctamente';
                this.processingMessage.showSuccessAlert(successMessage);
            },

            error: (error: string) => {
                let errorMessage = error ?? 'Se ha producido un error al actualizar los datos del participante';
                this.processingMessage.showDangerAlert(errorMessage);
            }

        }).add(() => {
            this.isProcessing = false;
        });

    }

    public createEntity() {

        this.isProcessing = true;
        this.studentService.post(this.student).subscribe({

            next: () => {
                let successMessage = 'El participante se ha dado de alta correctamente';
                this.processingMessage.showSuccessAlert(successMessage);
            },

            error: (error: any) => {
                let errorMessage = error.error.message ?? 'Se ha producido un error al crear el participante';
                this.processingMessage.showDangerAlert(errorMessage);
            }

        }).add(() => {
            this.isProcessing = false;
        });

    }

}
